module.exports = __webpack_public_path__ + "static/media/global-summit-logo.32776ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/global-summit-logo.png
// module id = 18
// module chunks = 0